import React, { useState, useEffect } from "react";
import { Col, Form, Row, TreeSelect } from "antd";
import LoadingButton from "@mui/lab/LoadingButton";

const SelectTransactionCategories = (props) => {
  const [buttonDisabled, setButtonDisabled] = useState(true);

  const onFormSubmit = (values) => {
    props.handleSelectCategories(values.categories);
  };

  const buildTree = (categories) => {
    const map = {};
    const tree = [];
    categories.forEach((cat) => {
      map[cat.id] = {
        value: cat.id,
        title: cat.name,
        children: [],
      };
    });
    categories.forEach((cat) => {
      const node = map[cat.id];
      if (cat.parent !== null && map[cat.parent]) {
        map[cat.parent].children.push(node);
      } else {
        tree.push(node);
      }
    });
    return tree;
  };

  const [treeData, setTreeData] = useState(() =>
    props.customCategories ? buildTree(props.customCategories) : []
  );

  const [defaultCategories, setDefaultCategories] = useState(() =>
    props.defaultCategories ? props.defaultCategories.map((tag) => tag.id) : []
  );

  useEffect(() => {
    if (props.customCategories) {
      setTreeData(buildTree(props.customCategories));
    }
  }, [props.customCategories]);

  useEffect(() => {
    if (props.defaultCategories) {
      setDefaultCategories(props.defaultCategories.map((tag) => tag.id));
    }
  }, [props.defaultCategories]);

  return (
    <Col span={24}>
      <Form
        onFinish={onFormSubmit}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Form.Item
          style={{
            margin: 0,
            padding: 0,
            width: "70%",
            marginRight: "10px",
          }}
          name="categories"
        >
          <TreeSelect
            style={{ width: "100%" }}
            showArrow
            treeCheckable
            defaultValue={defaultCategories}
            multiple
            dropdownStyle={{ maxHeight: 400, overflow: "auto", zIndex: 2000 }}
            placeholder="Please select"
            treeData={treeData}
            onFocus={() => setButtonDisabled(false)}
            onChange={() => setButtonDisabled(false)}
            allowClear
          />
        </Form.Item>

        <Row justify="end">
          <LoadingButton
            loading={props.inFlight}
            sx={{ fontSize: 14, textTransform: "none", width: "100%" }}
            disableElevation
            fullWidth
            size="small"
            type="submit"
            variant="contained"
            color="primary"
            htmlType="submit"
            disabled={buttonDisabled || props.inFlight}
          >
            Submit
          </LoadingButton>
        </Row>
      </Form>
    </Col>
  );
};

export default SelectTransactionCategories;
